import Settings from './Settings';

export default function createStub(namespace, callback) {
  if (!Settings.useServiceStubs) return;

  namespace.requires.push('ngMockE2E');
  namespace.run(callback);
}




/** WEBPACK FOOTER **
 ** ./src/olr-common/createStub.js
 **/